import { Component, Input, OnInit, inject } from '@angular/core'
import { SplashScreenService } from 'src/app/data/services/components/splash-screen/splash-screen.service'
import { Theme } from 'src/app/domain/enums/application/theme.enum'

@Component({ selector: 'app-splash-screen', templateUrl: './splash-screen.component.html', styleUrls: ['./splash-screen.component.scss'] })
export class SplashScreenComponent implements OnInit {
  // inject ->
  private splashScreenService: SplashScreenService = inject(SplashScreenService)

  // variables ->

  isShowSplashScreen: boolean = false

  @Input() selectedTheme: Theme = Theme.DEFAULT

  theme = Theme

  // state ->
  public ngOnInit(): void {
    this.splashScreenService.splashSubject.subscribe((display: boolean) => {
      this.changeDisplaySplashScreen(display)
    })
  }

  // change ->
  private changeDisplaySplashScreen(display: boolean): void {
    this.isShowSplashScreen = display
  }
}
